// extracted by mini-css-extract-plugin
export default {"verified":"EmailDomain_verified__BlSUY","pending":"EmailDomain_pending__7M2Uy","hint":"EmailDomain_hint__xh+pC","popup":"EmailDomain_popup__nRLRj"};